import i18n from '@/utils/i18n';
import React from 'react';
import { Skeleton, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const BODY_LINE_HEIGHT = 18;
const HEADER_HEIGHT = 56;
const TITLE_LINE_HEIGHT = 21;

export const HiddenAlertsSectionSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <YStack
      accessibilityLabel={i18n.t('loading')}
      accessibilityState={{ busy: true }}
      backgroundColor="$bgPrimaryDefault"
      borderColor="$borderPrimary"
      borderRadius="$12"
      borderWidth={1}
      marginBottom="$32"
      overflow="hidden"
    >
      <XStack
        alignItems="center"
        height={HEADER_HEIGHT}
        justifyContent="space-between"
        paddingHorizontal="$16"
      >
        <YStack>
          <YStack height={TITLE_LINE_HEIGHT} justifyContent="center">
            <Skeleton
              borderRadius={theme.sk.radii.radiusSmall}
              height={16}
              variant="rect"
              width={64}
            />
          </YStack>
          <YStack height={BODY_LINE_HEIGHT} justifyContent="center">
            <Skeleton
              borderRadius={theme.sk.radii.radiusSmall}
              height={14}
              variant="rect"
              width={220}
            />
          </YStack>
        </YStack>
        <Skeleton
          borderRadius={theme.sk.radii.radiusRound}
          height={24}
          variant="rect"
          width={48}
        />
      </XStack>
    </YStack>
  );
};
